import type { CSSProperties } from "react";
import React, { useContext, useEffect, useRef, useState } from "react";
import cn from "classnames";
import styles from "../styles/Skeleton.module.scss";
import type { ISkeletonBoxContext, ISkeletonCoverProps } from "../types";
import SkeletonBoxContext from "./SkeletonBoxContext";

export const SkeletonButton: React.FC<ISkeletonCoverProps> = ({
  className,
}) => {
  const context = useContext<ISkeletonBoxContext | null>(SkeletonBoxContext);
  const animStyle: CSSProperties = context?.style
    ? { width: context.style.width }
    : {};
  const [style, setStyle] = useState<CSSProperties>({});
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (ref.current?.parentElement && context) {
      const parentStyle = getComputedStyle(ref.current.parentElement);
      setStyle({ height: parentStyle.height });
    }
  }, [ref, ref.current]);
  return (
    <div ref={ref} className={cn(styles.button, className)} style={animStyle}>
      <span className={styles.skeleton} style={style} aria-busy="true">
        <span className={styles.skeleton__bg} aria-busy="true">
          <span className={styles.skeleton__anim} aria-busy="true" />
        </span>
      </span>
    </div>
  );
};
export default SkeletonButton;
